import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledPromotionCode = styled.div`
  display: flex;
  justify-content: flex-end;

  .promotion-code-input {
    width: 100%;
  }
  .promotion-code-row {
    display: flex;
    gap: 10px;
  }
  .promotion-code-text {
    text-align: right;

    .big {
      font-size: 16px;
      margin-bottom: 20px;
      background-color: ${Colors.darkBlue};
      border-radius: 10px;
      color: white;
      padding: 5px 10px;
    }
  }

  .promotion-code-totals {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;

    .ant-divider-horizontal {
      margin: 10px 0;
    }
  }

  .promotion-code-wrapper {
    width: 100%;
    background-color: ${Colors.backgroundPaleBlue};
    border-radius: 10px;
    border: 2px solid ${Colors.border};
    padding: 20px;
  }
`;
